define(['modules/CapsLockWarning'], function(CapsLockWarning) {
  function init() {
    var sign_in_tips = document.getElementsByClassName('js_sign_in_tips')[0];
    var forgot_password_trigger = document.getElementsByClassName('js_forgot_password_trigger')[0];
    var js_forgot_password = document.getElementsByClassName('js_forgot_password')[0];

    if (sign_in_tips.classList.contains('hide')) {
      var intervalId = setInterval(function() {
        var flashElement = document.getElementById('flash');
        if (flashElement && flashElement.classList.contains('alert')) {
          sign_in_tips.classList.remove('hide');
          clearInterval(intervalId); // Stop checking once we've shown the tips
        }
      }, 200)
    }

    if (forgot_password_trigger) {
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('js_forgot_password_trigger')) {
          if (js_forgot_password.offsetParent !== null) {
            hidePasswordHint(e, js_forgot_password);
          }
          else {
            js_forgot_password.style.display = 'block'
          }
          e.preventDefault();
        }
        else if (!(e.target.classList.contains('js_forgot_password'))) {
          hidePasswordHint(e, js_forgot_password);
        }
      });
    }

    document.addEventListener('keypress', function(e) {
      if (['student_password', 'staffer_password'].indexOf(e.target.getAttribute('id')) < 0) return;

      const capsWarning = document.getElementById('caps_warning');
      const capsLockOn = CapsLockWarning.isCapsLockOn(e);

      if (capsWarning) capsWarning.style.display = capsLockOn ? 'block' : 'none';
      CapsLockWarning.announceCapsLock(capsLockOn);
    });
  }

  function hidePasswordHint(e, el) {
    el.style.display = 'none';
  }

  return {
    init: init
  }
});